export const getMeetingRoomEntityId = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object') return String(value._id || value.id || '');
  return String(value);
};

export const isPublicMeetingRoom = (room) =>
  String(room?.visibility || 'private').toLowerCase() === 'public';

const EXTERNAL_SOURCES = new Set(['geoapify', 'serpapi', 'google', 'external']);

export const isExternalMeetingRoom = (room) =>
  EXTERNAL_SOURCES.has(String(room?.source || '').toLowerCase());

export const isMeetingRoomOwnedByUser = (room, user) => {
  const userId = getMeetingRoomEntityId(user?._id || user?.id);
  const roomOwnerId = getMeetingRoomEntityId(
    typeof room?.userId === 'object' ? room.userId : room?.userId || room?.hostId || room?.ownerId
  );
  return Boolean(userId && roomOwnerId && userId === roomOwnerId);
};

export const isSameCompanyMeetingRoom = (room, user) => {
  const roomCompanyId = getMeetingRoomEntityId(room?.companyId);
  const userCompanyId = getMeetingRoomEntityId(user?.company || user?.companyId);
  return Boolean(roomCompanyId && userCompanyId && roomCompanyId === userCompanyId);
};

/**
 * Public and external rooms → everyone.
 * Private company rooms → same companyId only (owners + employees).
 * Private individual rooms (no companyId) → room owner only.
 */
export const isMeetingRoomVisibleToUser = (room, user) => {
  if (!room) return false;
  if (isExternalMeetingRoom(room) || isPublicMeetingRoom(room)) return true;
  if (!user) return false;

  const roomCompanyId = getMeetingRoomEntityId(room?.companyId);
  if (roomCompanyId) {
    return isSameCompanyMeetingRoom(room, user);
  }

  return isMeetingRoomOwnedByUser(room, user);
};

export const isMeetingRoomBookableByUser = (room, user) =>
  isMeetingRoomVisibleToUser(room, user);

export const filterMeetingRoomsVisibleToUser = (rooms, user) => {
  if (!Array.isArray(rooms)) return [];
  return rooms.filter((room) => isMeetingRoomVisibleToUser(room, user));
};

export const filterMeetingRoomsBookableByUser = (rooms, user) =>
  filterMeetingRoomsVisibleToUser(rooms, user);
